import styled from 'styled-components';

export const TdmActionsRow = styled.div`
  display: flex;
  grid-gap: 8px;
`;
